import AppPageHeader from '../AppPageHeader';
import RankingTable from '../tables/RankingTable';
import React from 'react';
import PropTypes from 'prop-types';
import { Stack } from '@mui/system';

/**
 * Renders the ranking table tab for mobile.
 * @component
 * @param {Array<Object>} data - Data to display in ranking table
 * @param {Function} onRowClick - Table row click behaviour
 * @returns {React.ReactElement}
 */
const TableTab = ({ data, onRowClick }) => {
    return (
        <Stack spacing={1} sx={{ paddingTop: 2 }}>
            <AppPageHeader />
            <RankingTable
                filteredData={data}
                onRowClick={(event, item) => onRowClick(item)}
                tableVirtuosoProps={{ useWindowScroll: true }}
            />
        </Stack>
    );
};

TableTab.propTypes = {
    data: PropTypes.arrayOf(PropTypes.object),
    onRowClick: PropTypes.func
};

export default TableTab;
